/*
 * Components - 底部 Tab
 * @created: tanglijun(tang.lijun@centchain.com)
 */

import { mapState } from 'vuex'
import browser from "cy_static/browser"
import userUtil from "cy_static/userUtil"
import ajaxUtil from "cy_static/ajaxUtil"
import { reqCyQueryAdvert } from 'changyo-public-api'
import util from '@/assets/libs/util'

export default {
  name: 'FooterTab',
  computed: {
    ...mapState([
      'channel',
      'newMsgNumber'
    ])
  },
  data() {
    return {
      displayFooterTab: true,
      tabs: [
        {
          id: 'Homepage',
          name: '首页',
          icon: require('./images/icon-home1.png'),
          iconSelected: require('./images/icon-home-selected1.png'),
          host: true,
          tabSpm: '101616',
          gioData: {
            'pitCode': '101616',
            'pitPositionName': '底栏',
            'ModuleCode': 'C17_1',
            'ModuleName': '首页-底栏_首页'
          }
        },
        {
          id: 'cymall',
          name: '分类',
          icon: require('./images/icon-store1.png'),
          iconSelected: require('./images/icon-store-selected1.png'),
          host: true,
          tabSpm: '101619',
          gioData: {
            'pitCode': '101619',
            'pitPositionName': '底栏',
            'ModuleCode': 'C17_2',
            'ModuleName': '首页-底栏_分类'
          }
        },
        {
          id: 'hjf',
          name: '积分汇聚',
          icon: require('./images/hjf.png'),
          iconSelected: require('./images/hjf.png'),
          host: false,
          tabSpm: '101618',
          gioData: {
            'pitCode': '101618',
            'pitPositionName': '底栏',
            'ModuleCode': 'C17_2',
            'ModuleName': '首页-底栏_积分汇聚'
          }
        },
        {
          id: 'Member',
          name: '我的',
          icon: require('./images/icon-user1.png'),
          iconSelected: require('./images/icon-user-selected1.png'),
          host: true,
          tabSpm: '101620',
          gioData: {
            'pitCode': '101620',
            'pitPositionName': '我的',
            'ModuleCode': 'C17_5',
            'ModuleName': '首页-底栏_我的'
          }
        }
      ]
    }
  },
  mounted() {
    const currentTab = this.tabs.find(tab => tab.id === this.$route.name)

    currentTab.selected = true
    this.tabs = [...this.tabs]

    if (browser.jfmore) {
      this.displayFooterTab = true
    }

    // this.getTabsInfo()
  },
  methods:{
    gotoRouter(tab){
      if(tab.linkTo){
        location.href = tab.linkTo
      }else{
        this.$router.push(tab.id)
      }
    },
    async getTabsInfo() {
      const res = await reqCyQueryAdvert({
        featuredFirstCode: 'H5_new_midtab',
        channel: this.channel
      }).catch(err => {
        console.log(err)
      })

      if (res) {
        const tabs = res.data.advertiseOnlines.slice(0, 5)

        if (tabs.length >= 5) {

          // 数据排序
          const middleTab = tabs.pop()
          tabs.splice(2, 0, middleTab)
        } else {
          this.tabs.splice(2, 1)
          this.tabs = this.tabs.slice(0, this.tabs.length)
        }

        // 填充数据
        for (let i = 0; i < tabs.length; i++) {
          const tab = tabs[i]

          this.tabs[i].name = tab.advertiseIntroduce
          this.tabs[i].gioData = JSON.stringify({
            'pitCode': this.tabs[i].tabSpm,
            'pitPositionName': '底栏',
            'ModuleCode': 'C17_' + (i + 1),
            'ModuleName': '首页-底栏_' + this.tabs[i].name
          })

          if (i === 2 && tabs.length === 5) {
            this.tabs[i].icon = tab.advertiseViewImg

            if (util.validURL(tab.jumpLink)) {
              this.tabs[i].linkTo = tab.jumpLink
            }
          }
        }
      }
    }
  }
}
